import { Dispatch, SetStateAction, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { HEADER_HEIGHT, MOBILE_MAX_WIDTH } from 'src/assets/static/constants';
import { LoadingScreen } from 'src/components/loading-screen';
import ScrollToTop from 'src/components/scroll-to-top';

import { BasicHeader } from '../header';
import { HeaderProps } from '../header/BasicHeader';

export interface LayoutProps {
  setHeaderProps: Dispatch<SetStateAction<HeaderProps>>;
}

interface BasicLayoutProps {
  needHeader?: boolean;
}

function BasicLayout({ needHeader = true }: BasicLayoutProps) {
  const [headerProps, setHeaderProps] = useState<HeaderProps>({});

  return (
    <Container>
      {needHeader && <BasicHeader {...headerProps} />}
      <MainContainer>
        <Outlet context={{ setHeaderProps } as LayoutProps} />
      </MainContainer>
      <ScrollToTop />
      <LoadingScreen />
    </Container>
  );
}

const Container = styled('div')({
  width: '100%',
  height: '100vh',
  margin: 'auto',
  maxWidth: MOBILE_MAX_WIDTH,
});

const MainContainer = styled('main')({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  paddingTop: HEADER_HEIGHT,
});

export default observer(BasicLayout);
